import React from 'react';
import classNames from 'classnames';
import s from './ProductRibbons.scss';

export enum RibbonDataHook {
  Primary = 'product-ribbon-primary',
  Additional = 'product-ribbon-additional',
}

interface RibbonProps {
  text: string;
  dataHook: RibbonDataHook;
}

export const Ribbon: React.FC<RibbonProps> = ({text, dataHook}) => {
  const variantClass = dataHook === RibbonDataHook.Primary ? s.primaryRibbon : s.additionalRibbon;
  return (
    <div className={classNames(s.ribbon, variantClass)} data-hook={dataHook}>
      {text}
    </div>
  );
};
